import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';

export interface HealthCheckAnswer {
    value: string;
    response?: string;
}

export type HealthCheckAnswers = Record<string, HealthCheckAnswer>;

export const generateDocument = async (
    clientName: string,
    answers: HealthCheckAnswers,
): Promise<void> => {
    try {
        const response = await fetch(`/healthcheck/health-check-template.docx?t=${new Date().getTime()}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch template: ${response.statusText}`);
        }
        const content = await response.arrayBuffer();

        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
            delimiters: { start: '[[', end: ']]' },
        });

        const data: Record<string, string> = {
            ClientName: clientName,
        };

        Object.entries(answers).forEach(([key, answer]) => {
            if (answer.value === 'No' && answer.response) {
                data[`${key} answer`] = `No\nAction: ${answer.response}`;
            } else {
                data[`${key} answer`] = answer.value || '';
            }
        });

        const actionItems = Object.entries(answers)
            .filter(([, answer]) => answer.value === 'No' && answer.response)
            .map(([id, answer]) => `${id} - ${answer.response}`);

        data['action.list'] = actionItems.length > 0
            ? actionItems.join('\n\n')
            : 'No action items.';

        doc.render(data);

        const out = doc.getZip().generate({
            type: 'blob',
            mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });

        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const yyyy = now.getFullYear();
        const HH = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');

        const timestamp = `${dd}${mm}${yyyy}${HH}${min}`;
        const filename = `${clientName.replace(/\s+/g, '_')}_${timestamp}.docx`;

        saveAs(out, filename);
    } catch (error) {
        console.error('Error generating document:', error);
        alert('Failed to generate document. See console for details.');
    }
};
